import API from "@/shared/helpers/API";

// The console's Ably client. The device connection test builds the same one, so it tests the path the orders take
export function createAblyRealtime() {
	return new Ably.Realtime({
		authCallback: (tokenParams, callback) => {

			API.init().getAblyAuthToken((response) => {
				if(response && response.result === "OK") {
					callback(null, response.token_request);
				} else {
					callback(new Error('Failed to get Ably auth token:' + response.details ? response.details : 'Unknown error'));
				}
			});
		}
	});
}
